import axiosInstance from '../app/axios';

export const authAPI = {
  register: async (userData) => {
    const response = await axiosInstance.post('/auth/register', userData);
    return response.data;
  },

  login: async (credentials) => {
    const response = await axiosInstance.post('/auth/login', credentials);
    return response.data;
  },

  getMe: async () => {
    const response = await axiosInstance.get('/auth/me');
    return response.data;
  },

  updateMe: async (payload) => {
    const response = await axiosInstance.patch('/auth/me', payload);
    return response.data;
  },
};

export default authAPI;
